(function () {
  'use strict';

  var STORAGE_KEY = 'piecraft:shop-view';
  var CART_KEY = 'piecraft:cart-variants';

  function qs(sel, ctx) { return (ctx || document).querySelector(sel); }
  function qsa(sel, ctx) { return Array.from((ctx || document).querySelectorAll(sel)); }

  var page = qs('.collection-page');
  if (!page) return;

  /* ═══ VIEW TOGGLE ═══ */
  var grid = qs('.cp-grid', page);
  var viewBtns = qsa('.cp-view-btn', page);

  function setView(v) {
    if (!grid) return;
    grid.dataset.view = v;
    viewBtns.forEach(function (b) { b.classList.toggle('is-active', b.dataset.view === v); });
    try { localStorage.setItem(STORAGE_KEY, v); } catch (e) {}
  }

  viewBtns.forEach(function (btn) {
    btn.addEventListener('click', function () { setView(btn.dataset.view); });
  });

  var savedView = (function () {
    try { return localStorage.getItem(STORAGE_KEY); } catch (e) { return null; }
  })();
  if (savedView && (savedView === 'comfy' || savedView === 'dense')) {
    setView(savedView);
  } else {
    var defaultBtn = qs('.cp-view-btn[data-view="comfy"]', page);
    if (defaultBtn) defaultBtn.classList.add('is-active');
  }

  /* ═══ SORT ═══ */
  var sortSel = qs('.cp-sort-select', page);
  if (sortSel) {
    sortSel.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sortSel.value);
      window.location.assign(url.toString());
    });
  }

  /* ═══ FILTER AUTO-SUBMIT ═══ */
  var filterForm = qs('#CollectionFilterForm', page);
  if (filterForm) {
    var filterTimer;
    function submitFilter() {
      if (filterForm.requestSubmit) { filterForm.requestSubmit(); } else { filterForm.submit(); }
    }
    filterForm.addEventListener('change', function (e) {
      var t = e.target;
      if (t.type === 'range' || t.type === 'number') {
        clearTimeout(filterTimer);
        filterTimer = setTimeout(submitFilter, 150);
      } else {
        submitFilter();
      }
    });
  }

  /* ═══ CART STATE ═══ */
  function getCartIds() {
    try { return JSON.parse(sessionStorage.getItem(CART_KEY)) || []; } catch (e) { return []; }
  }
  function saveCartIds(ids) { try { sessionStorage.setItem(CART_KEY, JSON.stringify(ids)); } catch (e) {} }
  function addCartId(id) { var ids = getCartIds(); if (ids.indexOf(id) === -1) { ids.push(id); saveCartIds(ids); } }
  function isInCart(id) { return getCartIds().indexOf(id) !== -1; }

  function markButtonAdded(btn) {
    btn.dataset.added = '1';
    btn.classList.remove('cp-card__atc--clicked');
    btn.classList.add('cp-card__atc--added');
  }

  var animateAddTimer = null;

  function resetButton(btn) {
    btn.dataset.added = '';
    btn.dataset.busy = '0';
    btn.classList.remove('cp-card__atc--added', 'cp-card__atc--clicked');
    if (animateAddTimer) { clearTimeout(animateAddTimer); animateAddTimer = null; }
  }

  function animateAdd(btn) {
    btn.classList.add('cp-card__atc--clicked');
    btn.dataset.added = '1';

    var cartIcon = document.querySelector('cart-icon');
    if (cartIcon) {
      cartIcon.classList.remove('header-actions__cart-icon--bounce');
      void cartIcon.offsetWidth;
      cartIcon.classList.add('header-actions__cart-icon--bounce');
      setTimeout(function () { cartIcon.classList.remove('header-actions__cart-icon--bounce'); }, 600);
    }

    if (animateAddTimer) clearTimeout(animateAddTimer);
    animateAddTimer = setTimeout(function () {
      btn.classList.remove('cp-card__atc--clicked');
      btn.classList.add('cp-card__atc--added');
      animateAddTimer = null;
    }, 1500);
  }

  function updateCartCount() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var count = cart.total_quantity;
        var cartIcon = document.querySelector('cart-icon');
        if (cartIcon) {
          var bubbleCount = cartIcon.querySelector('.cart-bubble__count');
          if (bubbleCount) bubbleCount.textContent = count;
          var bubble = cartIcon.querySelector('.cart-bubble');
          if (bubble) {
            bubble.classList.toggle('visually-hidden', count === 0);
            if (count > 0) {
              bubble.classList.add('cart-bubble--animating');
              setTimeout(function () { bubble.classList.remove('cart-bubble--animating'); }, 400);
            }
          }
          cartIcon.classList.toggle('header-actions__cart-icon--has-cart', count > 0);
        }
      })
      .catch(function () {});
  }

  /* ═══ QUICK-ADD ═══ */
  function quickAdd(btn) {
    if (!btn || btn.dataset.busy === '1' || btn.dataset.added === '1') return;
    if (btn.dataset.available === 'false') return;
    var variantId = btn.dataset.variantId;
    if (!variantId) return;

    btn.dataset.busy = '1';

    var addPromise = fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: parseInt(variantId, 10), quantity: 1 })
    })
      .then(function (r) { if (!r.ok) throw new Error(); return r.json(); })
      .then(function () {
        addCartId(variantId);
        btn.dataset.busy = '0';
        animateAdd(btn);
        updateCartCount();

        /* Fetch cart + section HTML for theme components */
        return Promise.all([
          fetch('/cart.js').then(function (r) { return r.json(); }),
          fetch('/?section_id=cart-drawer-section').then(function (r) { return r.text(); })
        ]).then(function (results) {
          var cartData = results[0];
          var sectionHtml = results[1];
          return {
            cart: {
              id: cartData.token,
              totalQuantity: cartData.total_quantity,
              cost: { totalAmount: { amount: String(cartData.total_price / 100), currencyCode: cartData.currency } },
              lines: (cartData.items || []).map(function (item) {
                return { id: item.key, quantity: item.quantity, cost: { totalAmount: { amount: String(item.final_line_price / 100), currencyCode: cartData.currency } } };
              }),
              discountCodes: (cartData.discount_codes || []).map(function (dc) { return { code: dc.code, applicable: dc.applicable }; })
            },
            detail: { sections: { 'cart-drawer-section': sectionHtml } }
          };
        });
      })
      .catch(function () {
        btn.dataset.busy = '0';
        resetButton(btn);
      });

    /* Dispatch Shopify standard event — theme handles drawer open + content morph */
    var event = new CustomEvent('shopify:cart:lines-update', { bubbles: true });
    event.action = 'add';
    event.context = 'product';
    event.lines = [{ merchandiseId: variantId, quantity: 1 }];
    event.promise = addPromise;
    document.dispatchEvent(event);
  }

  /* ═══ SYNC ON LOAD ═══ */
  function applyCartState() {
    qsa('.cp-card__atc', page).forEach(function (btn) {
      var vid = btn.dataset.variantId;
      if (!vid) return;
      if (isInCart(vid)) {
        markButtonAdded(btn);
      } else {
        resetButton(btn);
      }
    });
  }

  function syncCartFromServer() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var serverIds = (cart.items || []).map(function (item) { return String(item.variant_id); });
        var localIds = getCartIds();
        var merged = localIds.slice();
        serverIds.forEach(function (id) { if (merged.indexOf(id) === -1) merged.push(id); });
        merged = merged.filter(function (id) { return serverIds.indexOf(id) !== -1; });
        saveCartIds(merged);
        applyCartState();

        var count = cart.total_quantity;
        var cartIcon = document.querySelector('cart-icon');
        if (cartIcon) {
          var bubble = cartIcon.querySelector('.cart-bubble');
          var bubbleCount = cartIcon.querySelector('.cart-bubble__count');
          if (bubbleCount) bubbleCount.textContent = count;
          if (bubble) bubble.classList.toggle('visually-hidden', count === 0);
          cartIcon.classList.toggle('header-actions__cart-icon--has-cart', count > 0);
        }
      })
      .catch(function () { applyCartState(); });
  }
  syncCartFromServer();

  document.addEventListener('cart:refresh', syncCartFromServer);
  document.addEventListener('cart:updated', syncCartFromServer);
  document.addEventListener('on:cart:add', syncCartFromServer);

  document.addEventListener('click', function (e) {
    if (e.target.closest('.cart-items__remove') || e.target.closest('[data-remove]') || e.target.closest('button[aria-label*="Remove"]')) {
      setTimeout(syncCartFromServer, 800);
    }
  });

  /* ═══ CLICK ═══ */
  page.addEventListener('click', function (e) {
    var btn = e.target.closest('.cp-card__atc');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();
    if (btn.dataset.added === '1' || btn.dataset.busy === '1') return;
    quickAdd(btn);
  }, true);

  /* ═══ KEYBOARD ═══ */
  page.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' && e.key !== ' ') return;
    var btn = e.target.closest('.cp-card__atc');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    if (btn.dataset.added === '1' || btn.dataset.busy === '1') return;
    quickAdd(btn);
  }, true);
})();
